import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API_BASE_URL } from "./api-config";
import { AuthenticationService } from "./authentication.service";
import { NativeHttpService } from "./native-http.service";

@Injectable({
  providedIn: "root",
})
export class WebApiService {
  readonly apiUrl = API_BASE_URL;

  constructor(private http: NativeHttpService, private authService: AuthenticationService) {}

  private getEnhancedOptions(options?: any): any {
    const currentUser = this.authService.currentUserValue;
    const enhancedOptions = { ...options };
    
    if (!enhancedOptions.headers) {
      enhancedOptions.headers = {};
    }
    
    if (currentUser) {
      const userPermissions = this.authService.currentUserPermissions;
      if (userPermissions && userPermissions.length > 0) {
        enhancedOptions.headers['X-User-Role'] = userPermissions[0].toString();
        enhancedOptions.headers['X-User-Permissions'] = userPermissions.join(',');
      }
      
      if (currentUser.roles && currentUser.roles.length > 0) {
        enhancedOptions.headers['X-User-Role-Id'] = currentUser.roles[0].id.toString();
        enhancedOptions.headers['X-User-Role-Name'] = currentUser.roles[0].name;
      }
    }
    
    return enhancedOptions;
  }

  get(endpoint: string, options?: any): Observable<any> {
    return this.http.get(`${this.apiUrl}/${endpoint}`, this.getEnhancedOptions(options));
  }

  post(endpoint: string, data: any, options?: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/${endpoint}`, data, this.getEnhancedOptions(options));
  }

  put(endpoint: string, data: any, options?: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${endpoint}`, data, this.getEnhancedOptions(options));
  }

  delete(endpoint: string, options?: any): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${endpoint}`, this.getEnhancedOptions(options));
  }
}
